



































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Color, UmuFlg } from '@/constants/constants';
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_140_HaisoIrai_ChildHeader_Table',
  components: {
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Color,
    UmuFlg,
    headers: [
      {
        text: '№',
        value: 'numberOrder',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 50,
      },
      {
        text: '品目',
        value: 'himmoku',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: false,
        width: 410,
      },
      {
        text: '単位',
        value: 'tani',
        sortable: false,
        width: 60,
      },
      {
        text: '入数',
        value: 'irisu',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 60,
      },
      {
        text: '年産',
        value: 'nensan',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 50,
      },
      {
        text: '賞味期限',
        value: 'shomiKigenYmd',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 100,
      },
      {
        text: 'c/s数量',
        value: 'haisoIraiSuryo',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 90,
      },
      {
        text: 'バラ数量',
        value: 'haisoIraiHasu',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 90,
      },
      {
        text: '重量',
        value: 'haisoIraiJuryo',
        sortable: false,
        class: 'text-end',
        cellClass: 'text-end',
        width: 90,
      },
      {
        text: '備考',
        value: 'meisaiBiko',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: false,
        width: 400,
      },
    ],
  }),
});
